import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { FiUploadCloud } from "react-icons/fi";
// import { PiDownloadSimpleBold } from "react-icons/pi";
import { MdDelete } from "react-icons/md";
import { TbMailShare } from "react-icons/tb";
import { GiNetworkBars } from "react-icons/gi";
import { BsFillLuggageFill } from "react-icons/bs";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { FaRegFilePdf } from "react-icons/fa6";
// import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import useMinimumLoading from "../hooks/Useminimumloading";
import { API_URL } from "../../Config";

const Payments = () => {
  // const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const options = ["Invoices", "Refunds"];
  const [invoiceData, setInvoiceData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    setCurrentPage_invoice(1);
    setCurrentPage_refund(1);
  }, [searchQuery]);
  // const navigate = useNavigate();

  const statusColors = {
    CANCELLED: "bg-amber-800/20 text-amber-800",
    CONFIRMED: "bg-green-500/20 text-green-500",
    BOOKED: "bg-purple-500/20 text-purple-500",
    FAILED: "bg-red-500/20 text-red-500",
    PENDING: "bg-yellow-200/40 text-yellow-300",
    PAID: "bg-transparent text-green-500",
    UNPAID: "bg-transparent text-red-400",
  };

  const table_payment = [
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
  ];

  const rowsPerPage_payment = 20;
  const [currentPage_payment, setCurrentPage_payment] = useState(1);

  const indexOfLastTable_payment = currentPage_payment * rowsPerPage_payment;
  const indexOfFirstTable_payment =
    indexOfLastTable_payment - rowsPerPage_payment;

  const current_payment = table_payment.slice(
    indexOfFirstTable_payment,
    indexOfLastTable_payment,
  );

  const totalPages_payment = Math.ceil(
    table_payment.length / rowsPerPage_payment,
  );

  const handlePageChange_payment = (pageNumber_payment) => {
    setCurrentPage_payment(pageNumber_payment);
  };

  const handleNextPage_payment = () => {
    if (currentPage_payment < totalPages_payment) {
      setCurrentPage_payment(currentPage_payment + 1);
    }
  };

  const handlePrevPage_payment = () => {
    if (currentPage_payment > 1) {
      setCurrentPage_payment(currentPage_payment - 1);
    }
  };

  const generatePageNumbers_payment = () => {
    const pageNumbers_payment = [];

    if (totalPages_payment <= 3) {
      for (let i = 1; i <= totalPages_payment; i++) {
        pageNumbers_payment.push(i);
      }
    } else {
      if (currentPage_payment > 2) {
        pageNumbers_payment.push(1);
        pageNumbers_payment.push("...");
      }
      for (let i = currentPage_payment - 1; i <= currentPage_payment + 1; i++) {
        if (i > 0 && i <= totalPages_payment) {
          pageNumbers_payment.push(i);
        }
      }
      if (currentPage_payment < totalPages_payment - 1) {
        pageNumbers_payment.push("...");
        pageNumbers_payment.push(totalPages_payment);
      }
    }
    return pageNumbers_payment;
  };

  const [selectedRows_payment, setSelectedRows_payment] = useState([]);

  const handleRowCheckboxChange_payment = (order) => {
    setSelectedRows_payment((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_payment = () => {
    if (selectedRows_payment.length === current_payment.length) {
      setSelectedRows_payment([]);
    } else {
      setSelectedRows_payment(current_payment.map((booking) => booking.order));
    }
  };
  const currentDate = new Date();
  const [showModal, setShowModal] = useState(false);
  const [month, setMonth] = useState(currentDate.getMonth() + 1);
  const [year, setYear] = useState(currentDate.getFullYear());

  const table_invoice = [
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
  ];

  const rowsPerPage_invoice = 20;
  const [currentPage_invoice, setCurrentPage_invoice] = useState(1);

  const indexOfLastTable_invoice = currentPage_invoice * rowsPerPage_invoice;
  const indexOfFirstTable_invoice =
    indexOfLastTable_invoice - rowsPerPage_invoice;

  // const current_invoice = table_invoice.slice(
  //   indexOfFirstTable_invoice,
  //   indexOfLastTable_invoice,
  // );

  // const totalPages_invoice = Math.ceil(
  //   table_invoice.length / rowsPerPage_invoice,
  // );
  const filteredInvoiceData = [...invoiceData]
    .sort((a, b) => b.bookingid - a.bookingid)
    .filter((b) => {
      if (!searchQuery.trim()) return true;
      const q = searchQuery.toLowerCase();
      return (
        b.bookingid?.toString().toLowerCase().includes(q) ||
        `${b.firstname} ${b.lastname}`.toLowerCase().includes(q) ||
        b.email?.toLowerCase().includes(q) ||
        b.property?.toLowerCase().includes(q)
      );
    });
  const totalPages_invoice = Math.ceil(
    filteredInvoiceData.length / rowsPerPage_invoice,
  );
  const current_invoice = filteredInvoiceData.slice(
    indexOfFirstTable_invoice,
    indexOfLastTable_invoice,
  );

  const handlePageChange_invoice = (pageNumber_invoice) => {
    setCurrentPage_invoice(pageNumber_invoice);
  };

  const handleNextPage_invoice = () => {
    if (currentPage_invoice < totalPages_invoice) {
      setCurrentPage_invoice(currentPage_invoice + 1);
    }
  };

  const handlePrevPage_invoice = () => {
    if (currentPage_invoice > 1) {
      setCurrentPage_invoice(currentPage_invoice - 1);
    }
  };

  const generatePageNumbers_invoice = () => {
    const pageNumbers_invoice = [];

    if (totalPages_invoice <= 3) {
      for (let i = 1; i <= totalPages_invoice; i++) {
        pageNumbers_invoice.push(i);
      }
    } else {
      if (currentPage_invoice > 2) {
        pageNumbers_invoice.push(1);
        pageNumbers_invoice.push("...");
      }
      for (let i = currentPage_invoice - 1; i <= currentPage_invoice + 1; i++) {
        if (i > 0 && i <= totalPages_invoice) {
          pageNumbers_invoice.push(i);
        }
      }
      if (currentPage_invoice < totalPages_invoice - 1) {
        pageNumbers_invoice.push("...");
        pageNumbers_invoice.push(totalPages_invoice);
      }
    }
    return pageNumbers_invoice;
  };

  const [selectedRows_invoice, setSelectedRows_invoice] = useState([]);

  // const handleRowCheckboxChange_invoice = (order) => {
  //   setSelectedRows_invoice((prevSelected) =>
  //     prevSelected.includes(order)
  //       ? prevSelected.filter((id) => id !== order)
  //       : [...prevSelected, order]
  //   );
  // };

  const handleSelectAll_invoice = () => {
    if (selectedRows_invoice.length === current_invoice.length) {
      setSelectedRows_invoice([]);
    } else {
      setSelectedRows_invoice(current_invoice.map((booking) => booking.order));
    }
  };

  const table_refund = [
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "Pre-Paid",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "COD",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "Pre-Paid",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "COD",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
  ];

  const rowsPerPage_refund = 20;
  const [currentPage_refund, setCurrentPage_refund] = useState(1);

  const indexOfLastTable_refund = currentPage_refund * rowsPerPage_refund;
  const indexOfFirstTable_refund = indexOfLastTable_refund - rowsPerPage_refund;
  const filteredRefundData = searchQuery.trim()
    ? table_refund.filter((b) => {
        const q = searchQuery.toLowerCase();
        return (
          b.order?.toLowerCase().includes(q) ||
          b.customer?.toLowerCase().includes(q) ||
          b.productName?.toLowerCase().includes(q)
        );
      })
    : table_refund;

  const totalPages_refund = Math.ceil(
    filteredRefundData.length / rowsPerPage_refund,
  );
  const current_refund = filteredRefundData.slice(
    indexOfFirstTable_refund,
    indexOfLastTable_refund,
  );

  // const current_refund = table_refund.slice(
  //   indexOfFirstTable_refund,
  //   indexOfLastTable_refund,
  // );

  //const totalPages_refund = Math.ceil(table_refund.length / rowsPerPage_refund);

  const handlePageChange_refund = (pageNumber_refund) => {
    setCurrentPage_refund(pageNumber_refund);
  };

  const handleNextPage_refund = () => {
    if (currentPage_refund < totalPages_refund) {
      setCurrentPage_refund(currentPage_refund + 1);
    }
  };

  const handlePrevPage_refund = () => {
    if (currentPage_refund > 1) {
      setCurrentPage_refund(currentPage_refund - 1);
    }
  };

  const generatePageNumbers_refund = () => {
    const pageNumbers_refund = [];

    if (totalPages_refund <= 3) {
      for (let i = 1; i <= totalPages_refund; i++) {
        pageNumbers_refund.push(i);
      }
    } else {
      if (currentPage_refund > 2) {
        pageNumbers_refund.push(1);
        pageNumbers_refund.push("...");
      }
      for (let i = currentPage_refund - 1; i <= currentPage_refund + 1; i++) {
        if (i > 0 && i <= totalPages_refund) {
          pageNumbers_refund.push(i);
        }
      }
      if (currentPage_refund < totalPages_refund - 1) {
        pageNumbers_refund.push("...");
        pageNumbers_refund.push(totalPages_refund);
      }
    }
    return pageNumbers_refund;
  };

  const [selectedRows_refund, setSelectedRows_refund] = useState([]);

  const handleRowCheckboxChange_refund = (order) => {
    setSelectedRows_refund((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_refund = () => {
    if (selectedRows_refund.length === current_refund.length) {
      setSelectedRows_refund([]);
    } else {
      setSelectedRows_refund(current_refund.map((booking) => booking.order));
    }
  };

  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

  const fileInputRef = useRef(null);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [active, setActive] = useState("Invoices");

  // const options = ["Payments", "Invoices", "Refunds"];

  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const showLoader = useMinimumLoading(loadingInvoice);

  useEffect(() => {
    if (active === "Invoices") {
      const fetchInvoices = async () => {
        setLoadingInvoice(true);
        try {
          const res = await fetch(`${API_URL}/getPaidBookings`);
          const json = await res.json();
          if (json.success) {
            setInvoiceData(json.data);
          }
        } catch (error) {
          console.error("Error fetching invoices:", error);
        } finally {
          setLoadingInvoice(false);
        }
      };
      fetchInvoices();
    }
  }, [active]);
  const handleSendInvoice = async (bookingid) => {
    try {
      const response = await fetch(`${API_URL}/sendInvoiceEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookingid }),
      });

      const data = await response.json();
      if (data.success) {
        alert("✅ Invoice sent successfully to customer!");
      } else {
        alert("❌ Failed to send invoice: " + data.message);
      }
    } catch (err) {
      console.error("Error sending invoice:", err);
      alert("⚠️ Error sending invoice.");
    }
  };
  // const handleDownloadInvoice = async (bookingid) => {
  //   try {
  //     const response = await fetch(
  //       "https://dash.zorbastays.com/web-backend/downloadInvoice",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ bookingid }),
  //       },
  //     );

  //     if (!response.ok) throw new Error("Failed to download");

  //     // Convert response to blob
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create temp <a> link
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `invoice-${bookingid}.pdf`;
  //     document.body.appendChild(a);
  //     a.click();

  //     // Cleanup
  //     a.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (err) {
  //     console.error("Error downloading invoice:", err);
  //     alert("⚠️ Failed to download invoice.");
  //   }
  // };

  const handleDownload = () => {
    window.open(
      `${API_URL}/paidbookingscsv?month=${month}&year=${year}`,
      "_blank",
    );
    setShowModal(false);
  };
  // Replace your existing setActive calls with this handler:
  const handleTabChange = (tab) => {
    setActive(tab);
    setSearchQuery("");
    setCurrentPage_invoice(1);
    setCurrentPage_refund(1);
  };
  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Payment & Invoicing
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search Invoice"
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="text-gray-500 hover:text-black text-lg font-bold px-1"
                  >
                    ×
                  </button>
                )}
              </div>

              <div className="">
                <button className="Btn" onClick={() => setShowModal(true)}>
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>
              {showModal && (
                <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                  <div className="bg-white p-6 rounded-xl w-[300px]">
                    <h2 className="text-lg font-semibold mb-4">
                      Select Month & Year
                    </h2>

                    {/* Month Dropdown */}
                    <select
                      className="w-full border p-2 rounded mb-3"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                    >
                      {[
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ].map((m, index) => (
                        <option key={index} value={index + 1}>
                          {m}
                        </option>
                      ))}
                    </select>

                    {/* Year Dropdown */}
                    <select
                      className="w-full border p-2 rounded mb-4"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    >
                      {[2024, 2025, 2026, 2027].map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>

                    {/* Buttons */}
                    <div className="flex justify-end gap-2">
                      <button
                        className="px-3 py-1 bg-gray-300 rounded"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>

                      <button
                        className="px-3 py-1 bg-green-900 text-white rounded"
                        onClick={handleDownload}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Boxes */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Total Revenue</p>
              <p className="mt-2 text-lg text-black">
                53,000 <sup className="text-green-500">+55%</sup>
              </p>
            </div>

            <div>
              <GiNetworkBars className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Pending Payments</p>
              <p className="mt-2 text-lg text-black">
                23 <sup className="text-green-500">+5%</sup>
              </p>
            </div>

            <div>
              <BsFillLuggageFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Revenue by Property</p>
              <p className="mt-2 text-lg text-black">
                $173,000 <sup className="text-green-500">+8%</sup>
              </p>
            </div>

            <div>
              <FaMoneyBillTrendUp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 mt-8">
          {/* Segmented buttons */}
          <div>
            <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm">
              {options.map((option) => (
                <button
                  key={option}
                  onClick={() => handleTabChange(option)}
                  className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${
                    active === option
                      ? "bg-[#1D2826] text-white"
                      : "bg-white text-gray-500 hover:bg-green-50"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {/* Button */}
          <div>
            <button
              onClick={() => setIsOpen_popupForm(true)}
              className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              + Add Payment
            </button>

            <div className="relative z-50">
              {isOpen_popupForm && (
                <div
                  onClick={() => setIsOpen_popupForm(false)}
                  className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
                />
              )}

              <div
                className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
                  isOpen_popupForm ? "translate-x-0" : "translate-x-full"
                } panel_popupForm`}
              >
                <div className="p-4 flex justify-between items-center border-b header_popupForm">
                  <h2 className="text-[#1D2826] text-lg font-semibold">
                    Add Payment
                  </h2>
                  <button
                    onClick={() => setIsOpen_popupForm(false)}
                    className="text-gray-500 hover:text-black text-xl"
                  >
                    <MdCancel />
                  </button>
                </div>

                <div className="p-4">
                  <div className="font-semibold text-gray-500 text-sm text-right">
                    Payment ID:{" "}
                    <span className="text-black my-1">10294837</span>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        First Name
                      </label>
                      <input
                        placeholder="Enter first name"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Last Name
                      </label>
                      <input
                        placeholder="Enter last name"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Email
                      </label>
                      <input
                        placeholder="Enter your email"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Phone Number
                      </label>
                      <input
                        placeholder="Enter phone number"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Country
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select your country</option>
                        <option value="">India</option>
                        <option value="">Japan</option>
                        <option value="">Singapore</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        City
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select your city</option>
                        <option value="">Rajkot</option>
                        <option value="">Ahmedabad</option>
                        <option value="">Junagadh</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Package | destination
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">
                          Select your package | destination
                        </option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Booking Date & Time
                      </label>
                      <input
                        type="text"
                        readOnly
                        value={new Date().toLocaleString()}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md text-black"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        OTA
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select OTA</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Booking Status
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select booking status</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Payment Status
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select payment status</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Property
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select a property</option>
                        <option value="Villa Serenity">Villa Serenity</option>
                        <option value="Villa Arcadia">Villa Arcadia</option>
                        <option value="Villa Mandovi">Villa Mandovi</option>
                        <option value="Villa Sal">Villa Sal</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full sm:col-span-2">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        ID Proof
                      </label>

                      <div
                        onClick={handleBoxClick}
                        className="border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center text-center p-6 cursor-pointer hover:border-black transition-all"
                      >
                        <FiUploadCloud className="w-10 h-10 text-green-600 mb-2" />

                        <p className="text-sm font-medium text-black">
                          Select File to Upload
                        </p>
                        <p className="text-xs text-gray-400">Image or PDF</p>

                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*,.pdf"
                          className="hidden"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => setIsOpen_popupForm(false)}
                        className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                      >
                        Cancel
                      </button>

                      <button className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div>
          {active === "Payments" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_payment}
                          checked={
                            selectedRows_payment.length ===
                              current_payment.length &&
                            current_payment.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Name</th>
                      <th className="p-4 w-1/10">Payment</th>
                      <th className="p-4 w-1/10">Booking Date</th>
                      <th className="p-4 w-1/12">Status</th>
                      <th className="p-4 w-1/10">Payment</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_payment.map((table_payment, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_payment(
                                  table_payment.order,
                                )
                              }
                              checked={selectedRows_payment.includes(
                                table_payment.order,
                              )}
                            />
                          </td>

                          <td
                            className="px-4 py-3"
                            data-full-content={table_payment.customer}
                          >
                            <Tooltip
                              title={table_payment.customer}
                              placement="left"
                            >
                              {table_payment.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_payment.productName}
                              placement="left"
                            >
                              {table_payment.productName}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_payment.date}
                              placement="left"
                            >
                              {table_payment.date}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[table_payment.status]
                                } `}
                              >
                                {table_payment.status}
                              </button>
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_payment.payment}
                              placement="left"
                            >
                              {table_payment.payment}
                            </Tooltip>
                          </td>

                          <td>
                            <div className="flex">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() => setIsOpen_popupForm(true)}
                              >
                                <FaEye size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() => setIsOpen_popupForm(true)}
                              >
                                <FaEdit size={14} />
                              </button>
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {indexOfFirstTable_payment + 1}-
                    {Math.min(indexOfLastTable_payment, table_payment.length)}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {table_payment.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_payment}
                      disabled={currentPage_payment === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>
                  {generatePageNumbers_payment().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_payment(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                            currentPage_payment === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}
                  <li>
                    <button
                      onClick={handleNextPage_payment}
                      disabled={currentPage_payment === totalPages_payment}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Invoices" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_invoice}
                          checked={
                            selectedRows_invoice.length ===
                              current_invoice.length &&
                            current_invoice.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Name</th>
                      <th className="p-4 w-1/10">Invoice</th>
                      <th className="p-4 w-1/10">Check In</th>
                      <th className="p-4 w-1/10">Check Out</th>
                      <th className="p-4 w-1/12">Status</th>
                      <th className="p-4 w-1/10">Payment</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>

                  {/* <tbody>
                    {loadingInvoice ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          Loading...
                        </td>
                      </tr>
                    ) : invoiceData.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          No paid bookings found
                        </td>
                      </tr>
                    ) : (
                      invoiceData.map((booking, index) => (
                        <tr
                          key={booking.bookingid}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input type="checkbox" />
                          </td>
                          <td className="px-4 py-3">
                            {booking.firstname} {booking.lastname}
                          </td>
                          <td className="px-4 py-3">{booking.bookingid}</td>
                          <td className="px-4 py-3">
                            {new Date(booking.checkin).toLocaleDateString() ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3">
                            {new Date(booking.checkout).toLocaleDateString() ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3">
                            <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">
                              {booking.paymentstatus}
                            </span>
                          </td>
                          <td className="px-4 py-3">{booking.btocprice}</td>
                          <td>
                            <div className="flex">
                              <div className="flex gap-2 mx-auto items-center">
                                <button
                                  className="px-2 py-1 text-gray-400 hover:text-green-700 hover:scale-125 transition-all duration-300"
                                  onClick={() =>
                                    handleSendInvoice(booking.bookingid)
                                  }
                                >
                                  <RiChatForwardLine size={20} />
                                </button>
                                <button className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300">
                                  <FaEye size={15} />
                                </button>
                                <button className="px-1 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300">
                                  <PiDownloadSimpleBold size={15} />
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody> */}
                  <tbody>
                    {showLoader ? (
                      <tr>
                        <td colSpan="10" className="text-center py-4">
                          <Loader
                            label="Loading..."
                            fullScreen={false}
                            className="py-2"
                          />
                        </td>
                      </tr>
                    ) : invoiceData.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          No paid bookings found
                        </td>
                      </tr>
                    ) : (
                      current_invoice.map((booking) => (
                        <tr
                          key={booking.bookingid}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input type="checkbox" />
                          </td>
                          <td className="px-4 py-3">
                            {booking.firstname} {booking.lastname}
                          </td>
                          <td className="px-4 py-3">{booking.bookingid}</td>
                          <td className="px-4 py-3">
                            {new Date(booking.checkin).toLocaleDateString() ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3">
                            {new Date(booking.checkout).toLocaleDateString() ||
                              "N/A"}
                          </td>
                          <td className="px-4 py-3">
                            <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">
                              {booking.paymentstatus}
                            </span>
                          </td>
                          <td className="px-4 py-3">{booking.btocprice}</td>
                          <td>
                            <div className=" ">
                              <div className="flex gap-2 mx-auto items-center">
                                <button
                                  className="px-2 py-1 text-gray-400 hover:text-green-700 hover:scale-125 transition-all duration-300"
                                  onClick={() =>
                                    handleSendInvoice(booking.bookingid)
                                  }
                                >
                                  <TbMailShare size={20} />
                                </button>
                                <button
                                  className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                  onClick={() =>
                                    window.open(
                                      `/invoice/${booking.bookingid}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <FaRegFilePdf size={14} />
                                </button>
                                {/* <button className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300">
                                    <FaEye size={15} />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDownloadInvoice(booking.bookingid)
                                    }
                                    className="px-1 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                  >
                                    <PiDownloadSimpleBold size={15} />
                                  </button> */}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {indexOfFirstTable_invoice + 1}-
                    {Math.min(indexOfLastTable_invoice, table_invoice.length)}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {table_invoice.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_invoice}
                      disabled={currentPage_invoice === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>
                  {generatePageNumbers_invoice().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_invoice(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                            currentPage_invoice === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}
                  <li>
                    <button
                      onClick={handleNextPage_invoice}
                      disabled={currentPage_invoice === totalPages_invoice}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Refunds" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_refund}
                          checked={
                            selectedRows_refund.length ===
                              current_refund.length && current_refund.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Name</th>
                      <th className="p-4 w-1/10">Refund</th>
                      <th className="p-4 w-1/10">Booking Date</th>
                      <th className="p-4 w-1/12">Status</th>
                      <th className="p-4 w-1/10">Payment</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_refund.map((table_refund, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_refund(
                                  table_refund.order,
                                )
                              }
                              checked={selectedRows_refund.includes(
                                table_refund.order,
                              )}
                            />
                          </td>

                          <td
                            className="px-4 py-3"
                            data-full-content={table_refund.customer}
                          >
                            <Tooltip
                              title={table_refund.customer}
                              placement="left"
                            >
                              {table_refund.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_refund.productName}
                              placement="left"
                            >
                              {table_refund.productName}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip title={table_refund.date} placement="left">
                              {table_refund.date}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[table_refund.status]
                                } `}
                              >
                                {table_refund.status}
                              </button>
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_refund.payment}
                              placement="left"
                            >
                              {table_refund.payment}
                            </Tooltip>
                          </td>

                          <td>
                            <div className="flex">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() => setIsOpen_popupForm(true)}
                              >
                                <FaEye size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() => setIsOpen_popupForm(true)}
                              >
                                <FaEdit size={14} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {indexOfFirstTable_refund + 1}-
                    {Math.min(indexOfLastTable_refund, table_refund.length)}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {table_refund.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_refund}
                      disabled={currentPage_refund === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>
                  {generatePageNumbers_refund().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_refund(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                            currentPage_refund === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}
                  <li>
                    <button
                      onClick={handleNextPage_refund}
                      disabled={currentPage_refund === totalPages_refund}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Payments;
